import React, { Component, PropTypes } from 'react';
import { Form, SubmissionError, Field } from 'redux-form';
import difference from 'lodash/difference';
import concat from 'lodash/concat';
import AnimatedButton from 'common/components/animated_button';
import ModalDialog from 'common/components/modal/modal_dialog';
import EntryPickerField from 'presentations/components/entry_picker_field';
import { MAX_SELECTED_REVISIONS } from 'presentations/constants';

export default class EditRevisionsModal extends Component {
  constructor(props) {
    super(props);

    this.handleClose = this.handleClose.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(formData) {
    const { addRequest, removeRequest, fetch, initialValues, presentationRevisions } = this.props;

    const revisionsToAdd = difference(
      formData.selected_revisions, initialValues.selected_revisions
    );
    const revisionsToRemove = difference(
      initialValues.selected_revisions, formData.selected_revisions
    );

    const addPromises = revisionsToAdd.map(r => addRequest({ revision: r }));
    const removePromises = revisionsToRemove.map(r => {
      const presentationRev = presentationRevisions.find(rev => rev.revision.id === r);
      return removeRequest(presentationRev.id);
    });

    return Promise.all(concat(addPromises, removePromises)).then(() => {
      /* fetch update revisions list and close modal */
      fetch();
      this.handleClose();
    }).catch(res => {
      throw new SubmissionError({ _error: 'Failed to update entries. Please try again.' });
    });
  }

  handleClose() {
    this.props.reset();
    this.props.toggle();
  }

  render() {
    const {
      showing, handleSubmit, submitting, error, submitFailed, valid, selected, submit
    } = this.props;

    return (
      <ModalDialog modalOpen={showing} closeAction={this.handleClose}
        modalHeader="Presentation Entries" dialogClasses="edit-revisions-modal" contentClasses="wide">

        <Form onSubmit={handleSubmit(this.handleSubmit)}>
          <div className="row">
            <div className="columns medium-16 large-12">
              <h2>
                Edit Entries
                <span className="entry-count">
                  ({ selected.length } / { MAX_SELECTED_REVISIONS } selected)
                </span>
              </h2>
            </div>
          </div>
          <Field name="selected_revisions" component={EntryPickerField} />
        </Form>

        <div className="modal-actions">
          <AnimatedButton processing={submitting} onClick={submit}
            disabled={!valid && !submitFailed} label="Save" processingLabel="Saving..."
            errorMsg={error || submitFailed} />
          <button className="btn btn-text" onClick={this.handleClose}>
            Cancel
          </button>
        </div>
      </ModalDialog>
    );
  }
};

EditRevisionsModal.propTypes = {
  addRequest: PropTypes.func.isRequired,
  removeRequest: PropTypes.func.isRequired,
  fetch: PropTypes.func.isRequired,
  toggle: PropTypes.func.isRequired,
  presentationRevisions: PropTypes.array.isRequired,
  selected: PropTypes.array.isRequired,
  showing: PropTypes.bool.isRequired,
};



// WEBPACK FOOTER //
// ./presentations/components/edit_revisions_modal.jsx